export type Faq = {
  q: string
  a: string
}

export const FAQS: Faq[] = [
  {
    q: 'WHAT IS KIDS LEARNING READY™?',
    a: 'A complete digital visual learning system designed to make essential childhood concepts easier to understand, review and remember.',
  },
  {
    q: 'WHO IS IT FOR?',
    a: 'Parents, teachers, tutors, homeschoolers, caregivers and anyone helping a child learn.',
  },
  {
    q: 'IS IT A PHYSICAL PRODUCT?',
    a: 'No. KIDS LEARNING READY™ is completely digital and available immediately after purchase.',
  },
  {
    q: 'HOW CAN I USE IT?',
    a: 'For teaching, homework, tutoring, homeschool, quick review or independent learning.',
  },
  {
    q: 'DO I HAVE TO USE EVERYTHING?',
    a: 'No. Simply choose the resources that match what the child is currently learning or needs to reinforce.',
  },
  {
    q: 'ARE THE 4 BONUSES INCLUDED?',
    a: 'Yes. All four strategic bonuses are included with this offer.',
  },
  {
    q: 'HOW LONG DO I HAVE ACCESS?',
    a: 'You receive lifetime access to the digital materials included with your purchase.',
  },
  {
    q: 'WHAT AGES IS IT DESIGNED FOR?',
    a: 'The visual resources cover essential concepts children work on through their primary school years, and each area can be used earlier or later depending on what the child is learning.',
  },
  {
    q: 'DO I NEED TO PRINT EVERYTHING?',
    a: 'No. You can print only the sets you need, use them on screen, or laminate and add them to a keyring for repeated use.',
  },
  {
    q: 'WHAT IF IT IS NOT RIGHT FOR ME?',
    a: 'You are protected by a 7-day money-back guarantee. Explore the full system and if it is not right for the way you help a child learn, contact us within 7 days for a refund.',
  },
]
